/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Form_LabelInputs */



/**
* | output |
* | --- |
* | "Metadata form" |
*
* @param {Event_Group_Metadata_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_form_label = /** @type {((inputs?: Event_Group_Metadata_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Formulaire de métadonnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadatenformular")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modulo metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Форма метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formulario de metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据表单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータフォーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा फ़ॉर्म")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formulário de metadados")
	return /** @type {LocalizedString} */ ("Metadata form")
});